import { useCallback, useContext, useMemo } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import { useQuery } from '@tanstack/react-query'
import { CvsTextField, CvsTreeSelect } from '@components'
import { folderContext } from '@contexts'
import { BOX_MANUAL_FOLDER_ENABLED } from './field-configs'
import { templateCopyContext } from '../../../context'
import { CheckboxField } from '../../components'

const TreeSelect = styled(CvsTreeSelect as any)`
  margin-top: 24px;
  margin-left: 12px;
`

interface BoxFolderSelectionProps {
  assignment: any
}

export const BoxFolderSelection = ({ assignment }: BoxFolderSelectionProps) => {
  const { onChange } = useContext<any>(templateCopyContext)
  const { fetchBoxFolders } = useContext<any>(folderContext)

  const isEnabled = key =>
    assignment?.metadata?.[key] !== '0' && Boolean(assignment?.metadata?.[key])

  const getChildFolders = useCallback(
    id => {
      if (assignment.connector_id) {
        return fetchBoxFolders(id, assignment.connector_id).then(resp => resp?.data)
      }
      return null
    },
    [assignment.connector_id, fetchBoxFolders],
  )

  const { data: root } = useQuery({
    queryKey: ['boxFolders', assignment.connector_id],
    queryFn: () => getChildFolders(0),
    enabled: !!assignment.connector_id,
  })

  const onBoxChange = useCallback(
    (value, name) => {
      onChange(old => ({
        ...old.integrationsById,
        [assignment.id]: {
          ...assignment,
          [name]: value,
        },
      }))
    },
    [assignment, onChange],
  )

  const onSelected = useCallback(
    value => {
      onBoxChange(value, 'folder_name')
    },
    [onBoxChange],
  )

  const selected = useMemo(() => String(assignment.folder_name ?? ''), [assignment.folder_name])

  return (
    <>
      <CheckboxField
        label={t`Input folder ID manually`}
        integrationAssignment={assignment}
        checked={isEnabled(BOX_MANUAL_FOLDER_ENABLED)}
        metadataKey={BOX_MANUAL_FOLDER_ENABLED}
      />
      {isEnabled(BOX_MANUAL_FOLDER_ENABLED) ? (
        <CvsTextField
          label={t`Folder ID`}
          name="folder_name"
          fullWidth
          onChange={({ target }) => {
            onBoxChange(target.value, 'folder_name')
          }}
          value={selected}
        />
      ) : (
        <TreeSelect
          root={root}
          fetchChildren={getChildFolders as any}
          onSelected={onSelected as any}
          selected={selected}
        />
      )}
    </>
  )
}
